<template>
  <PageHeaderLayout>
    <el-row style="margin-top: 80px; display:flex">
      <el-form :inline="true" :model="searchCondition">
        <el-form-item label="姓名">
          <el-input v-model="searchCondition.name" placeholder="输入姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <DatePicker @dataSearch="dataSearch"/>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchButton" style="color: #1890ff">查询</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <ApeTable
      ref="apeTable"
      :data="dataList"
      :columns="columns"
      :loading="loadingStaus"
      :pagingData="pagingData"
      highlight-current-row
      @switchPaging="switchPaging"
    >
      <el-table-column
        width="300"
        align="left"
        label="操作"
      >
        <template slot-scope="scope">
          <span class="btn-wrapper" v-if="scope.row.alias_status == '待提交'">
            <el-button size="mini" type="primary" @click="submitBnt(scope.row.id)">查看</el-button>
          </span>
        </template>
      </el-table-column>
    </ApeTable>
  </PageHeaderLayout>
</template>
<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from '@/components/DatePicker.vue'
export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker
  },
  data() {
    return {
      columns: [
        {
          title: "名称",
          value: "name",
          header_align: "center",
          align: "center",
        },
        {
          title: "税号",
          value: "taxpayer",
          header_align: "center",
          align: "center",
        },
        {
          title: "电话号码",
          value: "mobile",
          header_align: "center",
          align: "center",
        },
        {
          title: "开户银行",
          value: "bank",
          header_align: "center",
          align: "center",
        },
        {
          title: "银行账户",
          value: "bank_card",
          header_align: "center",
          align: "center",
        },
        {
          title: "开票金额",
          value: "money",
          header_align: "center",
          align: "center",
        },
        {
          title: "开票类目",
          value: "category",
          header_align: "center",
          align: "center",
        },
      ],
      dataList: [
      {
        "buy": {
          "id": "212954863088336896",
          "tenant_id": "0",
          "mini_user_id": null,
          "name": "",
          "taxpayer": "",
          "address": "",
          "mobile": "",
          "bank": "",
          "bank_card": "",
          "created_at": "2021-01-27 15:26:35",
          "updated_at": "2021-01-27 15:26:35",
          "deleted_at": null
        },
        "sale": {
          "id": "212960597091979265",
          "agent_buy_id": "212954863088336896",
          "name": "",
          "address": "",
          "mobile": "",
          "idcard": "",
          "idcard_front": "",
          "idcard_back": "",
          "industry": "",
          "category": "131196054272318021",
          "specs": "",
          "unit": "",
          "number": 0,
          "money": "0.00",
          "created_at": "2021-01-27 15:49:22",
          "updated_at": "2021-01-27 15:49:22"
        }
      },
      {
        "buy": {
          "id": "212954863088336896",
          "tenant_id": "0",
          "mini_user_id": null,
          "name": "",
          "taxpayer": "",
          "address": "",
          "mobile": "",
          "bank": "",
          "bank_card": "",
          "created_at": "2021-01-27 15:26:35",
          "updated_at": "2021-01-27 15:26:35",
          "deleted_at": null
        },
        "sale": {
          "id": "212955496898002944",
          "agent_buy_id": "212954863088336896",
          "name": "",
          "address": "",
          "mobile": "",
          "idcard": "",
          "idcard_front": "",
          "idcard_back": "",
          "industry": "请选择行业",
          "category": "请选择开票类目",
          "specs": "",
          "unit": "",
          "number": 0,
          "money": "0.00",
          "created_at": "2021-01-27 15:29:06",
          "updated_at": "2021-01-27 15:29:06"
        }
      },
      {
        "buy": {
          "id": "212954863088336896",
          "tenant_id": "0",
          "mini_user_id": null,
          "name": "",
          "taxpayer": "",
          "address": "",
          "mobile": "",
          "bank": "",
          "bank_card": "",
          "created_at": "2021-01-27 15:26:35",
          "updated_at": "2021-01-27 15:26:35",
          "deleted_at": null
        },
        "sale": {
          "id": "212955075890544640",
          "agent_buy_id": "212954863088336896",
          "name": "",
          "address": "",
          "mobile": "",
          "idcard": "",
          "idcard_front": "",
          "idcard_back": "",
          "industry": "请选择行业",
          "category": "请选择开票类目",
          "specs": "",
          "unit": "",
          "number": 0,
          "money": "0.00",
          "created_at": "2021-01-27 15:27:26",
          "updated_at": "2021-01-27 15:27:26"
        }
      },
      {
        "buy": {
          "id": "212901221861830657",
          "tenant_id": "0",
          "mini_user_id": "1",
          "name": "111",
          "taxpayer": "222",
          "address": "232",
          "mobile": "18603821907",
          "bank": "1212",
          "bank_card": "额哇额哇",
          "created_at": "2021-01-27 11:53:26",
          "updated_at": "2021-01-27 11:53:26",
          "deleted_at": null
        },
        "sale": {
          "id": "212929441961238529",
          "agent_buy_id": "212901221861830657",
          "name": "测试1",
          "address": "地址2",
          "mobile": "18603821902",
          "idcard": "411527199511087265",
          "idcard_front": "",
          "idcard_back": "",
          "industry": "",
          "category": "128940888252014591",
          "specs": "",
          "unit": "",
          "number": 0,
          "money": "20.00",
          "created_at": "2021-01-27 13:45:35",
          "updated_at": "2021-01-27 13:45:35"
        }
      },
      {
        "buy": {
          "id": "212901221861830657",
          "tenant_id": "0",
          "mini_user_id": "1",
          "name": "111",
          "taxpayer": "222",
          "address": "232",
          "mobile": "18603821907",
          "bank": "1212",
          "bank_card": "额哇额哇",
          "created_at": "2021-01-27 11:53:26",
          "updated_at": "2021-01-27 11:53:26",
          "deleted_at": null
        },
        "sale": {
          "id": "212929157931356161",
          "agent_buy_id": "212901221861830657",
          "name": "测试",
          "address": "地址",
          "mobile": "18603821901",
          "idcard": "411527199511087265",
          "idcard_front": "",
          "idcard_back": "",
          "industry": "",
          "category": "128940888252014591",
          "specs": "美丽",
          "unit": "万元",
          "number": 2,
          "money": "20.00",
          "created_at": "2021-01-27 13:44:27",
          "updated_at": "2021-01-27 13:44:27"
        }
      }
    ],
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      searchCondition: {}
    };
  },
  methods: {
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.start_time = value[0]
      this.searchCondition.end_time = value[1]
    },
    //初始化代开列表
    async init(type) {
      if(type) {
        this.mxResetPage()
      }
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type == 'search') {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getInvoiceList(pagingInfo)
      this.$nextTick(() => {
        this.dataList=list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.start_time) {
        condition.start_time =  this.searchCondition.start_time
      }
      if (this.searchCondition.end_time) {
        condition.end_time = this.searchCondition.end_time
      }
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      return condition
    },
    switchPaging() {
      this.init()
    },
    searchButton() {
      this.init('search')
    }
  },
};
</script>
<style lang="stylus" scoped>
</style>